import React from 'react';
import { useTranslation } from 'react-i18next';
import { ProfileDiscoverTracking } from '~/components/AccountGetsMarried/components/GetCare/components/NavTiles/util';
import useSelectFetchMostRecentBookingLocationDetails from '~/components/AccountGetsMarried/hooks/useSelectFetchMostRecentBookingLocationDetails';
import { FLU_SHOT_SERVICE_ID } from '~/constants/services';
import { analyticsTrackEvent } from '~/core/analytics';
import { DRAWER_TYPE_FLU_SHOT, NAV_TILE_CLICKED } from '~/core/analytics/events';
import { useHandleRouteCDPorUniversalSearch } from '~/hooks/useHandleRouteCDPorUniversalSearch';
import { Details, Icon, Root, SubTitle, Title } from '../../styles';
import useHasFluShots from './hooks/useHasFluShot';
import useTrackLoadFluShot from './hooks/useTrackLoadFluShot';

type Props = {
  userProfileId: string;
};

/*
  Returns the "flu year" of the given date.
  The "2022 flu year" runs from July 2022 through June 2023
 */
export const getFluYear = (date: Date = new Date()) => {
  if (date.getMonth() >= 6) {
    return date.getFullYear();
  }
  return date.getFullYear() - 1;
};

const BookFluShot = ({ userProfileId }: Props) => {
  const { location: prioritizedLocation } =
    useSelectFetchMostRecentBookingLocationDetails(userProfileId);

  const hasFluShots = useHasFluShots(prioritizedLocation);
  const handleRouteFluShot = useHandleRouteCDPorUniversalSearch(
    () => ProfileDiscoverTracking(DRAWER_TYPE_FLU_SHOT, prioritizedLocation),
    prioritizedLocation,
    hasFluShots,
    [FLU_SHOT_SERVICE_ID]
  );

  const onClick = () => {
    handleRouteFluShot();
    analyticsTrackEvent(NAV_TILE_CLICKED, {
      action: DRAWER_TYPE_FLU_SHOT,
    });
  };
  useTrackLoadFluShot(hasFluShots);

  const { t } = useTranslation(['account']);

  return (
    <Root onClick={onClick}>
      <Icon alt="book flu shot" src="/images/account/tiles/vaccine-new.svg" />
      <Details>
        <Title>{t('account:navTiles.flu.title')}</Title>
        <SubTitle>{t('account:navTiles.flu.subtitle', { YEAR: getFluYear() })}</SubTitle>
      </Details>
    </Root>
  );
};

export default BookFluShot;
